module.exports = __webpack_public_path__ + "img/fla.1422095a.svg";